var render, staticRenderFns
import script from "./BaseSlider.vue?vue&type=script&lang=ts&"
export * from "./BaseSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSlider.vue?vue&type=style&index=0&id=26d5028a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5028a",
  null
  
)

export default component.exports